import { ClipboardList } from "lucide-mui";
import Button from "@mui/material/Button";
import BulkActionBar from "../../../components/BulkActionBar.tsx";
import { formatNumber } from "../../../utils/format.ts";

interface BulkSelectionBarProps {
  selectedCount: number;
  addToListPending: boolean;
  onAddToListClick: () => void;
  onClear: () => void;
  selectAllMatching?: boolean;
  totalMatching?: number;
}

export default function BulkSelectionBar({
  selectedCount,
  addToListPending,
  onAddToListClick,
  onClear,
  selectAllMatching = false,
  totalMatching,
}: BulkSelectionBarProps) {
  if (selectedCount === 0 && !selectAllMatching) return null;
  return (
    <BulkActionBar
      count={selectedCount}
      label={
        selectAllMatching ? `All ${formatNumber(totalMatching ?? 0)} matching filter selected` : undefined
      }
      onClear={onClear}
      // Above the companies table, not under it.
      sticky={false}
      sx={{ mb: 2 }}
    >
      <Button
        size="small"
        variant="contained"
        startIcon={<ClipboardList />}
        onClick={onAddToListClick}
        loading={addToListPending}
      >
        Add to collection
      </Button>
    </BulkActionBar>
  );
}
